import React from 'react';
import WidgetsFactory from '../../shared/widgets/components/widgets-factory/widgets-factory-desktop';

import BreadcrumbsInterface from 'interfaces/breadcrumbs.interface';
import MainLayoutDesktop from 'layouts/main-layout/main-layout.desktop';
import PriceAlertEmailModal from '../../../views/components/modal/price-alert-modal/price-alert-email-modal';

import { withHydrate } from '@ecommerce/nest-ssr/common';
import { WidgetsFactoryInterface } from 'modules/shared/widgets/components/widgets-factory/widgets-factory.interfaces';
import BreadcrumbsDesktop from 'modules/shared/components/breadcrumbs/breadcrumbs.desktop';
import Container from 'atomic/container';

const CustomPagesDesktop: React.FC<{
    config: WidgetsFactoryInterface[];
    breadcrumbs: BreadcrumbsInterface[];
}> = ({ config, breadcrumbs }) => (
    <MainLayoutDesktop>
        <Container>
            <div className="row">
                <div className="col col-12">
                    <BreadcrumbsDesktop breadcrumbs={breadcrumbs}/>
                </div>
            </div>
        </Container>
        <WidgetsFactory config={config}/>
        <PriceAlertEmailModal/>
    </MainLayoutDesktop>
);

export default withHydrate(CustomPagesDesktop, { root: '#root' }, 'modules/custom-pages/views/custom-pages.desktop');
